import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthenticatedResponse, LoginNModel } from '../../components/Login/pro-view-login/pro-view-login.component';


@Injectable({
  providedIn: 'root'
})

export class LoginService {
  private LoginValidationUrl: string;
  private testurl: string;
  private _baseUrl: string;
  private SetSessionUrl: string;
  router: Router;

  constructor(private http: HttpClient) {//, @Inject('APP_BASE_HREF') private baseUrl: string) {
    this._baseUrl = ""; //environment.baseurl;
  }
  public getLoginValidation(userName: string, passWord: string): Observable<any> {
    let model = new LoginModel();
    model.Username = userName;
    model.Password = passWord;
    // model.RefreshToken = refreshtoken;
    return this.http.post<any>(this._baseUrl + this.LoginValidationUrl, model);
  }
  
  deleteSession() {
    return this.http.post("/LoginPage/DeleteSession", "", { responseType: 'text' });
  }
  getSession() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetSessiondata");
  }
  getSiteKey() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/getSiteKey");
  }
  getsname(sNumber:any,sName:any) {
    return this.http.post<any>(this._baseUrl + "/paragraphAction/togetsname?sNumber=" + sNumber + "&sName=" + sName, {});
  }

  verifyReCaptcha(token: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/VerifyCaptcha?captchaToken=" + token);
  }
  getlogo() {
    return this.http.get<any>(this._baseUrl + "/LoginPage/FasbLogo");
  }
  getlogoutURL(baseUrl: any) {
    return this.http.get<any>(this._baseUrl + "/LoginPage/GetLogoutURL?baseUrl=" + baseUrl);
  }
  validateCreds(creds: LoginNModel) {
    return this.http.post<AuthenticatedResponse>(this._baseUrl + "/LoginPage/login", creds, {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    })
  }
  getPDFBackupEnableFlag() {
    return this.http.get(this._baseUrl + "/LoginPage/GetDRPDFBackupFlag", { responseType: 'text' });
  }

  validateBasicView() {
    return this.http.post<AuthenticatedResponse>(this._baseUrl + "/LoginPage/loginBasicView", {
      headers: new HttpHeaders({ "Content-Type": "application/json" })
    })
  }
}
export class LoginModel {
  Username: string
  Password: string
  RefreshToken: string
}


